<script setup>
</script>
<template>
  <div class="xl:mt-4 relative w-full 2xl:h-[550px] xl:h-[500px] sm:h-[450px] h-[350px]">
    <iframe class="absolute top-20 w-full h-full" src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d116864.58544070323!2d90.56584800000002!3d23.746727000000003!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3755b9db50a0ae87%3A0x42f3ec4d1c856929!2sNo%20Chinta%20Limited!5e0!3m2!1sen!2sbd!4v1709456678019!5m2!1sen!2sbd"  style="border:0;" loading="lazy" referrerpolicy="no-referrer-when-downgrade" allowfullscreen allow="encrypted-media"></iframe>
</div>
</template>
<style scoped>
</style>
